import * as React from "react";
import {
    SiteTitleProps
} from "../@types/SiteTitle";



export const SiteTitleContext =
    React.createContext<React.PropsWithChildren<SiteTitleProps>>({ title: '' });

export const useSiteTitle = () => React.useContext(SiteTitleContext);

const SiteTitleProvider: React.FC<React.PropsWithChildren<SiteTitleProps>> = ({ title, children }) => {
    document.title = title !== undefined && title !== 'undefined' ? title : '';

    return (
        <SiteTitleContext.Provider value={{ title }}>
            {children}
        </SiteTitleContext.Provider>
    );
};
export default SiteTitleProvider;
